<section aria-labelledby="about" class="d-flex flex-column gap-4">
  <h3 class="self-enrolment-header" id="about" i18n>About</h3>
  <div [formGroup]="form" class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label [for]="'name'" class="form-input-label" i18n>Organization Name</label>
      <app-masked-text-input
        formControlName="name"
        controlId="name"
        [maskOptions]="maskitoOptions.name"
        [error]="formSubmitted && form.controls.name.invalid" />
      <div class="d-flex align-items-center gap-2">
        <app-form-error
          *ngIf="formSubmitted && form.controls.name.invalid"
          [errors]="form.controls.name.errors"
          [customErrorMessages]="customErrorMessages.name" />
        <div class="form-input-hint ms-auto" [class.name-error]="formSubmitted && form.controls.name.invalid">
          {{ form.controls.name.value?.length ?? 0 }}/60
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-2">
      <label [for]="'shortName'" class="form-input-label" i18n>Organization Short Name</label>
      <app-masked-text-input
        formControlName="shortName"
        controlId="shortName"
        [maskOptions]="maskitoOptions.shortName"
        [error]="formSubmitted && form.controls.shortName.invalid" />
      <div class="d-flex align-items-center gap-2">
        <app-form-error
          *ngIf="formSubmitted && form.controls.shortName.invalid"
          [errors]="form.controls.shortName.errors"
          [customErrorMessages]="customErrorMessages.shortName" />
        <div class="form-input-hint ms-auto" [class.name-error]="formSubmitted && form.controls.shortName.invalid">
          {{ form.controls.shortName.value?.length ?? 0 }}/50
        </div>
      </div>
    </div>
    <div class="d-flex flex-column gap-2">
      <label [for]="'craPayrollRemittanceAccountNumber'" class="form-input-label" i18n
        >CRA Payroll Remittance Number</label
      >
      <app-masked-text-input
        formControlName="craPayrollRemittanceAccountNumber"
        controlId="craPayrollRemittanceAccountNumber"
        [maskOptions]="maskitoOptions.craPayrollRemittanceAccountNumber"
        [error]="formSubmitted && form.controls.craPayrollRemittanceAccountNumber.invalid" />
      <div i18n class="form-input-hint">Optional</div>
    </div>
  </div>
</section>
